import { Fragment } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { FormattedPriceCalculationResponse } from "../constants";

import { centerJustifiedStyling } from "./card-container";
import { PriceDisplay } from "./price-display";
import { UserTier } from "./user-tier";

const annualContainerStyles = css(centerJustifiedStyling);

const annualDescriptionStyles = css({
    fontSize: "16px",
    lineHeight: "24px"
});

const userTierContainerStyles = css({
    margin: "15px 0 32px"
});

export type AnnualProps = {
    readonly priceCalc: FormattedPriceCalculationResponse;
    readonly fontSize: string;
    readonly planName: string;
};

export const Annual = ({ priceCalc, fontSize, planName }: AnnualProps) => (
    <Fragment>
        <PriceDisplay
            planName={planName}
            formattedPrice={priceCalc.formattedTotalPrice}
            fontSize={fontSize}
        />
        <div css={annualContainerStyles}>
            <div css={annualDescriptionStyles}>
                <FormattedMessage
                    id="Pricing.PriceCard.Annual.Description"
                    defaultMessage="per year"
                />
            </div>
            <div css={userTierContainerStyles}>
                <UserTier priceCalc={priceCalc} />
            </div>
        </div>
    </Fragment>
);
